import {DeviceProtocolDeviceMethodInterceptor} from "@hybird/device/interceptor/beginSeal/core";
import * as AMapLoader from "@amap/amap-jsapi-loader";
import {deviceError} from "@hybird/device/deviceError";
import {WebError} from "@hybird/core/error";
import {config} from "@hybird/device/config";

export class AMapLocationBeginSealInterceptor extends DeviceProtocolDeviceMethodInterceptor {
  async connect(proceed, self, params = {}) {
    //TODO self.deviceInfo.fence 电子围栏功能

    const result = getGeolocation().then(async location => {
      console.warn("获取到位置信息", JSON.stringify(location));
      let _config;

      if (params.config !== config) {
        _config = params.config;
        _config.gps = location;
        _config.address = location.address;
        config.address = location.address
        config.gps = location;
      } else {
        _config = config;
        config.gps = location;
        config.address = location.address
      }

      _config.address = location.address;

      if (self.deviceInfo.fence) {
        const data = self.deviceInfo.geoFence;

        await loadAMap(AMap => {
          for (const i in data) {
            const range = data[i].range ?? 500;
            const distance = AMap.GeometryUtil.distance([_config.gps.lon, _config.gps.lat], [data[i].lon, data[i].lat]);

            if (distance > range) {
              throw WebError.code(deviceError.GEOLOCATION_ERROR, {msg: "超出电子围栏"});
            }
          }
        })
      }
    }).catch(e => {
      console.warn("获取位置异常", e);

      if (!self.deviceInfo.fence) {
        return null;
      }

      throw e;
    });

    return proceed(params).then(async data => {
      await result;
      return data;
    });
  }

  get order() {
    return 10;
  }

  isSupport(deviceBeginSeal) {
    // return !isNode;
    return true
  }
}

export const isNode = () =>
        typeof process !== 'undefined' &&
        !!process.versions &&
        !!process.versions.node;

/**
 *
 * @param resolve{function(AMap)}
 * @param reject{function(Error)|null}
 */
export function loadAMap(resolve, reject = undefined) {
  if (window.AMap) {
    return resolve(window.AMap);
  } else {
    return AMapLoader.load({ //首次调用 load
      key: '19da3567642017c4e1644b052ea555ed',//首次load key为必填
      version: '2.0',
      plugins: ['AMap.Geolocation', 'AMap.Geocoder']
    }).then((AMap) => {
      window.AMap = AMap;
      return resolve(AMap);
    }).catch((e) => {
      const error = WebError.error(e, deviceError.GEOLOCATION_ERROR);
      if (reject) {
        return reject?.(error);
      } else {
        throw error;
      }
    });
  }
}

let _getGeolocation = async (AMap) => {
  return new Promise((resolve, reject) => {
    loadAMap((AMap) => {
      AMap.plugin(['AMap.Geolocation', 'AMap.Geocoder'], async function () {
        const geolocation = new AMap.Geolocation({
          enableHighAccuracy: true,//是否使用高精度定位，默认:true
          timeout: 10000,          //超过10秒后停止定位，默认：无穷大
          maximumAge: 0,           //定位结果缓存0毫秒，默认：0
          convert: true,           //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
          showButton: false,        //显示定位按钮，默认：true
          buttonPosition: 'LB',    //定位按钮停靠位置，默认：'LB'，左下角
          buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
          showMarker: true,        //定位成功后在定位到的位置显示点标记，默认：true
          showCircle: true,        //定位成功后用圆圈表示定位精度范围，默认：true
          panToLocation: true,     //定位成功后将定位到的位置作为地图中心点，默认：true
          zoomToAccuracy: true      //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        });

        const geocoder = new AMap.Geocoder();
        geolocation.getCurrentPosition();

        AMap.Event.addListener(geolocation, 'complete', (data) => {
          const lnglat = [data.position.lng, data.position.lat];
          geocoder.getAddress(lnglat, (status, result) => {
            if (status === 'complete' && result.info === 'OK') {
              //{"info":"OK","regeocode":{"addressComponent":{"citycode":"0571","adcode":"330108","businessAreas":[{"name":"长河","id":"330108","location":[120.1988,30.188826]},{"name":"西兴","id":"330108","location":[120.221721,30.194076]}],"neighborhoodType":"","neighborhood":"","building":"","buildingType":"","street":"江虹路","streetNumber":"459号","province":"浙江省","city":"杭州市","district":"滨江区","towncode":"330108003000","township":"长河街道"},"formattedAddress":"浙江省杭州市滨江区长河街道英飞特D英飞特科技园","roads":[],"crosses":[],"pois":[]}}
              console.log("定位数据", JSON.stringify(result));

              resolve({
                lon: data.position.lng,
                lat: data.position.lat,
                address: result.regeocode?.formattedAddress,
                province: result.regeocode?.addressComponent?.province,
                city: result.regeocode?.addressComponent?.city,
                township: result.regeocode?.addressComponent?.township,
                street: result.regeocode?.addressComponent?.street,
                district: result.regeocode?.addressComponent?.district,
              })
            } else {
              console.warn('逆地理编码失败:', result, lnglat);
              resolve({
                lon: data.position.lng,
                lat: data.position.lat,
              })
            }
          });
        });
        AMap.Event.addListener(geolocation, 'error', (data) => {
          console.log('定位失败', data);
          resolve(WebError.code(deviceError.GEOLOCATION_ERROR, {data: data}))
        });
      });
    }, (e) => {
      reject(WebError.error(e, deviceError.GEOLOCATION_ERROR));
    });
  })
}

export function setGeolocation(getGeolocation) {
  _getGeolocation = getGeolocation;
}

export async function getGeolocation() {
  return _getGeolocation();
}